import { createServiceHTTPClientProvider, createBoundServiceQueryHooksCreator, createBoundServiceMutationHookCreator } from "@airhelp/service-utils";
import { b as fetchOffers } from "./fetch-offers-Dxzm5j4P.js";
const [AhPlusHTTPClientProvider, useAhPlusHTTPClient] = createServiceHTTPClientProvider({
  name: "AhPlus"
});
const AH_PLUS_REACT_QUERY_KEY_PREFIX = "ah-plus";
const createAhPlusQueryHooks = createBoundServiceQueryHooksCreator({
  queryKeyPrefix: AH_PLUS_REACT_QUERY_KEY_PREFIX,
  useClient: useAhPlusHTTPClient
});
createBoundServiceMutationHookCreator({
  useClient: useAhPlusHTTPClient
});
const [useOffers, useOffersSuspense] = createAhPlusQueryHooks({
  queryFn: fetchOffers,
  queryKey: ["offers"]
});
export {
  AH_PLUS_REACT_QUERY_KEY_PREFIX,
  AhPlusHTTPClientProvider,
  useAhPlusHTTPClient,
  useOffers,
  useOffersSuspense
};
//# sourceMappingURL=react.js.map
